import React from 'react';
import { BannerConfirmation } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';

import { closeModal } from '../../Utils';

const continueClick = () => {
    closeModal('post-consent-invite-confirmation-modal');
    window.location.replace('/usis/advice/fps/profile');
};

const PostConsentInviteConfirmation = () => {
    return (
        <BannerConfirmation
            id={'post-consent-invite-confirmation'}
            title={`You've invited a co-client`}
            text={
                `We've sent an invitation to your co-client using the email address you provided. ` +
                `The PIN you provided expires in 21 days. After that, you'll need to resend the ` +
                `invite and provide a new PIN.`
            }
            rightButtonText={'Continue'}
            createClick={continueClick}
            noCloseButton
        />
    );
};

export default PostConsentInviteConfirmation;
